/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  advertisersRequest: ['filter'],
  advertisersSuccess: ['list'],
  advertisersReset: null,

  followingsAdvertisersRequest: null,
  followingsAdvertisersSuccess: ['list'],
  followingsAdvertisersReset: null,

  advertiserRequest: ['id'],
  advertiserSuccess: ['focusRow'],
  advertiserReset: null,

  deleteRestoreAdvertiserRequest: ['id', 'data'],
  deleteRestoreAdvertiserSuccess: ['deleteRestoreResult', 'id'],
  deleteRestoreAdvertiserReset: null,

  advertisersFetchingReset: null,

  followAuthorSuccess: ['authorId', 'followed'],
})

export const AdvertisersTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  deleteRestoreResult: null,
  deleteRestoreFetching: false,

  page: 1,
  page_size: 12,

  focusRow: null,
})

/* ------------- Selectors ------------- */
export const AdvertisersSelectors = {
  getState: state => state.advertisers,
}

/* ------------- Reducers ------------- */

export const advertisersRequest = (state, {filter}) => {
  return state.merge({fetching: true})
}

export const advertisersSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const advertisersReset = state => {
  return state.merge({
    list: null,
    fetching: false,

    deleteRestoreResult: null,
    deleteRestoreFetching: false,

    page: 1,
    page_size: 12,

    focusRow: null,
  })
}

export const followingsAdvertisersRequest = (state, {}) => {
  return state.merge({fetching: true})
}

export const followingsAdvertisersSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const advertiserRequest = (state, {id}) => {
  return state.merge({fetching: true})
}

export const advertiserSuccess = (state, {focusRow}) => {
  return state.merge({fetching: false, focusRow})
}

export const advertiserReset = state => {
  return state.merge({
    fetching: false,
    focusRow: null,
  })
}

export const advertisersFetchingReset = state => {
  return state.merge({
    fetching: false,
    deleteRestoreFetching: false,
  })
}

export const followAuthorSuccess = (state, {authorId, followed}) => {
  const newResults = state.list?.results.map(advertiser => {
    if (advertiser.id === authorId) {
      return {...advertiser, is_following: followed}
    } else {
      return {...advertiser}
    }
  })

  const newList = state.list ? {...state.list, results: [...newResults]} : null

  let newFocusRow = state.focusRow ? {...state.focusRow} : null
  if (state.focusRow) {
    if (state.focusRow.id === authorId) newFocusRow = {...state.focusRow, is_following: followed}
  }

  return state.merge({list: newList, focusRow: newFocusRow})
}

export const deleteRestoreAdvertiserRequest = (state, {id, data}) => {
  return state.merge({deleteRestoreFetching: true})
}
export const deleteRestoreAdvertiserSuccess = (state, {deleteRestoreResult, id}) => {
  console.log('advertiserId', id)
  if (state.list?.results) {
    const newResults = state.list?.results.filter(advertiser => +advertiser.id !== +id)
    const newList = {...state.list, results: [...newResults]}
    console.log('newList', newList)
    return state.merge({list: {...newList}, deleteRestoreFetching: false, deleteRestoreResult})
  } else {
    return state.merge({
      deleteRestoreFetching: false,
      deleteRestoreResult,
    })
  }
}
export const deleteRestoreAdvertiserReset = state => {
  return state.merge({deleteRestoreResult: null, deleteFetching: false})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.ADVERTISERS_REQUEST]: advertisersRequest,
  [Types.ADVERTISERS_SUCCESS]: advertisersSuccess,
  [Types.ADVERTISERS_RESET]: advertisersReset,

  [Types.FOLLOWINGS_ADVERTISERS_REQUEST]: followingsAdvertisersRequest,
  [Types.FOLLOWINGS_ADVERTISERS_SUCCESS]: followingsAdvertisersSuccess,

  [Types.ADVERTISER_REQUEST]: advertiserRequest,
  [Types.ADVERTISER_SUCCESS]: advertiserSuccess,
  [Types.ADVERTISER_RESET]: advertiserReset,

  [Types.DELETE_RESTORE_ADVERTISER_REQUEST]: deleteRestoreAdvertiserRequest,
  [Types.DELETE_RESTORE_ADVERTISER_SUCCESS]: deleteRestoreAdvertiserSuccess,
  [Types.DELETE_RESTORE_ADVERTISER_RESET]: deleteRestoreAdvertiserReset,

  [Types.ADVERTISERS_FETCHING_RESET]: advertisersFetchingReset,

  [Types.FOLLOW_AUTHOR_SUCCESS]: followAuthorSuccess,
})
